export const items = [
  {
    link: "https://github.com/moh-C",
    Name: "Github",
    contactID: "Moh-C",
    mediaIcon: "https://cdn.worldvectorlogo.com/logos/github-icon-1.svg",
    id: 0,
  },

  {
    link: "http://t.me/aaro_n",
    Name: "Telegram",
    contactID: "aaro_n",
    mediaIcon: "https://cdn.worldvectorlogo.com/logos/telegram.svg",
    id: 2,
  },
  {
    link: "mailto:mohammad.chegini@hotmail.com",
    Name: "Email",
    contactID: "Mohammad.Chegini",
    mediaIcon: "https://cdn.worldvectorlogo.com/logos/outlook-1.svg",
    id: 3,
  },
  {
    link: "https://www.linkedin.com/in/mohammad-chegini-079a72191/",
    Name: "LinkedIn",
    contactID: "+12254700456",
    mediaIcon: "https://cdn.worldvectorlogo.com/logos/linkedin-icon-2.svg",
    id: 7,
  },
  {
    link: "http://instagram.com/aaro_n46",
    Name: "Instagram",
    contactID: "aaro_n46",
    mediaIcon: "https://cdn.worldvectorlogo.com/logos/instagram-2016.svg",
    id: 1,
  },
  {
    link: "mailto:mochegini46@gmail.com",
    Name: "Gmail",
    contactID: "MoChegini46",
    mediaIcon: "https://cdn.worldvectorlogo.com/logos/gmail-icon.svg",
    id: 4,
  },
  {
    link: "skype:live:mohammad.chegini_1?chat",
    Name: "Skype",
    contactID: "live:mohammad.chegini_1",
    mediaIcon: "https://cdn.worldvectorlogo.com/logos/skype-3.svg",
    id: 5,
  },
  {
    link: "http://wa.me/12254700546",
    Name: "WhatsApp",
    contactID: "+12254700456",
    mediaIcon: "https://cdn.worldvectorlogo.com/logos/whatsapp-icon.svg",
    id: 6,
  },
];
